import React from "react";
import confetti from "canvas-confetti";

function Confetti() {
  const count = 100;
  const defaults = {
    origin: { y: 0.6 },
    disableForReducedMotion: true,
  };

  function fire(particleRatio, opts) {
    confetti(
      Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio),
      })
    );
  }
  
  fire(0.40, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });

  return;
}

export default Confetti;